export default __webpack_public_path__ + "static/media/Briar_Rose_Normal_B.7c74e521.wav";